/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Tab,
  Tabs,
} from '@mui/material';
import TabPanel from '../../../components/TabPanel';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

// Context
import useFootprintContext from '../context/useFootprintContext';

export default function EngagementFileModal() {
  const { engagementData, setEngagementData } = useContext(useFootprintContext);

  const fileAttachment = ['pdf', 'ppt', 'pptm', 'csv', 'xlsx', 'xls', 'pptx'];
  const otherFile = ['csv', 'xlsx', 'xls', 'pptx'];
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setEngagementData({ ...engagementData, toggle: false, data: [] });
  };
  return (
    <Dialog
      fullWidth
      maxWidth='xl'
      open={engagementData?.toggle}
      PaperProps={{
        sx: {
          width: '100%',
          height: 1000,
        },
      }}
      onClose={() => handleClose()}
    >
      <DialogTitle>
        Engagement Viewer
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 850 }} p={2}>
          <Tabs
            orientation='vertical'
            variant='scrollable'
            value={value}
            onChange={handleChange}
            aria-label='Vertical tabs example'
            sx={{ borderRight: 1, borderColor: 'divider' }}
          >
            {engagementData?.data.map((row, index) => (
              <Tab
                label={`File ${index + 1}`}
                id={`file-${index}-tab`}
                aria-controls={`file-${index}-tab`}
                name={`file-${index}-tab`}
              />
            ))}
          </Tabs>
          {engagementData?.data.map((row, index) => (
            <TabPanel
              value={value}
              index={index}
              p={0}
              m={0}
              sx={{
                width: 1300,
                height: '100%',
              }}
            >
              <Box display='flex' alignItems='center' justifyContent='center'>
                {fileAttachment.includes(row?.file_type) ? (
                  <iframe
                    title={row?.file_name || 'No file'}
                    src={
                      otherFile.includes(row?.file_type)
                        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                            row?.file_link,
                          )}`
                        : `https://docs.google.com/gview?url=${encodeURIComponent(
                            row?.file_link,
                          )}&embedded=true`
                    }
                    style={{
                      height: '450px',
                      width: '100%',
                    }}
                  />
                ) : (
                  <Box
                    component='img'
                    sx={{
                      height: '30%',
                      width: '60%',
                    }}
                    src={row?.file_link || ''}
                    alt={row?.file_name || 'No file'}
                  />
                )}
              </Box>
            </TabPanel>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
